import { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../hooks/useTranslation';
import AuthModal from '../components/AuthModal';
import CreatePostModal from '../components/CreatePostModal';
import PostCard from '../components/PostCard';
import styles from './PostsPage.module.css';

function PostsPage() {
  const { currentUser } = useAuth();
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const q = query(collection(db, 'posts'), orderBy('createdAt', 'desc'), limit(20));
        const snapshot = await getDocs(q);
        const postsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPosts(postsData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const refreshPosts = async () => {
    try {
      const q = query(collection(db, 'posts'), orderBy('createdAt', 'desc'), limit(20));
      const snapshot = await getDocs(q);
      const postsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPosts(postsData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching posts:', error);
    }
  };

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.loading}>{t('posts.loading')}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>{t('posts.title')}</h1>
          <div className={styles.subtitleTipBox}>
            <p>{t('posts.subtitle')}</p>
          </div>

          {currentUser ? (
            <button
              type="button"
              className={styles.createPostBtn}
              onClick={() => setShowCreateModal(true)}
            >
              {t('posts.askQuestion')}
            </button>
          ) : (
            <button
              type="button"
              className={styles.createPostBtn}
              onClick={() => setShowAuthModal(true)}
            >
              {t('posts.askQuestion')}
            </button>
          )}
        </div>
        {posts.length > 0 ? (
          <div className={styles.postsList}>
            {posts.map((post) => (
              <PostCard key={post.id} post={post} currentUser={currentUser} />
            ))}
          </div>
        ) : (
          <div className={styles.empty}>{t('posts.noPosts')}</div>
        )}
      </div>
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
      {showCreateModal && (
        <CreatePostModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={refreshPosts}
        />
      )}
    </div>
  );
}

export default PostsPage;

